export const UI_TOOLS_MATOMO_EVENT_CATEGORY_HEADER = 'Header';
